export var TipoProjetoFundiariosEnum;
(function (TipoProjetoFundiariosEnum) {
    TipoProjetoFundiariosEnum["Gleba"] = "GLEBA";
    TipoProjetoFundiariosEnum["Assentamento"] = "ASSENTAMENTO";
    TipoProjetoFundiariosEnum["LoteamentoUrbano"] = "LOTEAMENTO_URBANO";
    TipoProjetoFundiariosEnum["COHAB"] = "COHAB";
})(TipoProjetoFundiariosEnum || (TipoProjetoFundiariosEnum = {}));
(function (TipoProjetoFundiariosEnum) {
    var mapDescricao = new Map([
        [TipoProjetoFundiariosEnum.Gleba, "Gleba"],
        [TipoProjetoFundiariosEnum.Assentamento, "Assentamento"],
        [TipoProjetoFundiariosEnum.LoteamentoUrbano, "Loteamento Urbano"],
        [TipoProjetoFundiariosEnum.COHAB, "Cohab"]
    ]);
    function getDescricao(key) {
        return mapDescricao.get(key);
    }
    TipoProjetoFundiariosEnum.getDescricao = getDescricao;
    function getOptions() {
        var list = [];
        mapDescricao.forEach(function (label, value) {
            list.push({ label: label, value: value });
        });
        return list;
    }
    TipoProjetoFundiariosEnum.getOptions = getOptions;
})(TipoProjetoFundiariosEnum || (TipoProjetoFundiariosEnum = {}));
